import type { StyleSettingsToggleCombinedProps } from './types';

const usePresenter = (props: StyleSettingsToggleCombinedProps): StyleSettingsToggleCombinedProps => {
  return props;
};

export default usePresenter;
